export const changeImagenParams = (
  url: string,
  sw: number,
  sh: number,
  q: number
): string => {
  return url
    .replace(/sw=\d+/, `sw=${sw}`)
    .replace(/sh=\d+/, `sh=${sh}`)
    .replace(/q=\d+/, `q=${q}`);
};
